import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'robot-vacuum',
  size: 24,
  node: [
    ['path', { d: 'M11 17h2', key: '12w5me' }],
    ['path', { d: 'M12 12h.01', key: '1mp3jc' }],
    ['path', { d: 'M17 12a5 5 0 00-10 0', key: '7ltzr3' }],
    ['path', { d: 'M19 2v2.8', key: '5fivdr' }],
    ['path', { d: 'M2 5h2.8', key: '1hq9iq' }],
    ['path', { d: 'M22 5h-2.8', key: '1w5mcv' }],
    ['path', { d: 'M5 2v2.8', key: '1aozhq' }],
    ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name RobotVacuum
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEgMTdoMiIgLz4KICA8cGF0aCBkPSJNMTIgMTJoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xNyAxMmE1IDUgMCAwMC0xMCAwIiAvPgogIDxwYXRoIGQ9Ik0xOSAydjIuOCIgLz4KICA8cGF0aCBkPSJNMiA1aDIuOCIgLz4KICA8cGF0aCBkPSJNMjIgNWgtMi44IiAvPgogIDxwYXRoIGQ9Ik01IDJ2Mi44IiAvPgogIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjEwIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/robot-vacuum
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RobotVacuum = createLucideIcon(__iconData);

export default RobotVacuum;
